export default __webpack_public_path__ + "static/media/iusa.1f05449f.png";